import React, { useEffect, useState } from "react";
import getSudoku from "../ReusableParts/getSudoku";
import Board from "./Board/Board";
import BoardRender from "./Board/BoardRender";
import Logic from "./Board/Logic";
import "./index.css";
import SudokuControlPanel from "./SudokuControlPanel";
type Props = {};

function Sudoku({}: Props) {
  const [curSudoku, setCurSudoku] = useState(getSudoku());
  const [difficulty, setDifficulty] = useState<"EASY" | "MEDIUM" | "HARD">(
    "MEDIUM"
  );
  const [clear, setClear] = useState<Boolean>(false);
  const [showProcess, setShowProcess] = useState<Boolean>(true);
  const [progressSpeed, setProgressSpeed] = useState<number>(1000);
  const [reachedHere, setReachedHere] = useState<number[]>();
  const [startSolving, setStartSolving] = useState<Boolean>(false);
  const [progress, setProgress] = useState<number>(0);
  useEffect(() => {
    if (clear) {
      setCurSudoku(getSudoku);
      setReachedHere([]);
      setClear(false);
    }
  }, [clear]);

  const solveHandler = async () => {
    const tempSudoku = Logic(curSudoku, 0, 0);
    if (showProcess) {
      let processed = JSON.parse(localStorage.getItem("processed")!!);
      const lastUpdated = JSON.parse(localStorage.getItem("last")!!);
      console.log(processed);
      const len = processed.length;
      console.log(curSudoku + " pops");
      let i = 0;
      for (const grid of processed) {
        if (clear) {
          processed = [];
          break;
        }
        setCurSudoku(grid);
        setReachedHere(lastUpdated[i]);
        setProgress((100 * i) / len);
        i++;
        await new Promise((__) => setTimeout(__, progressSpeed));
      }
    } else {
      console.log(tempSudoku);
      setCurSudoku(() => tempSudoku);
    }
  };
  useEffect(() => {
    if (startSolving) solveHandler();
  }, [startSolving]);

  return (
    <div className="Sudoku">
      <BoardRender
        returnObj={curSudoku}
        showProcess={showProcess}
        reachedHere={reachedHere}
        progress={progress}
        difficulty={difficulty}
      />
      {!startSolving && (
        <SudokuControlPanel
          setStartSolving={setStartSolving}
          setProgressSpeed={setProgressSpeed}
          setClear={setClear}
          setCurSudoku={setCurSudoku}
          setDifficulty={setDifficulty}
        />
      )}
    </div>
  );
}

export default Sudoku;
